export default "__VITE_ASSET__BNjGHV2x__"